import { cn } from '@/lib/cn';

/**
 * Scalloped edge — the signature motif from Rachele's logo label (a cut-paper /
 * pastry-box edge). Place at the top of a coloured section: the bar is the colour
 * of the section ABOVE, biting scallops into the section below.
 */
export function Scallop({ className, color = 'var(--color-cream)' }: { className?: string; color?: string }) {
  return (
    <div
      aria-hidden
      className={cn('pointer-events-none absolute inset-x-0 top-0 h-[22px] -translate-y-px', className)}
      style={{
        backgroundColor: color,
        WebkitMaskImage: 'radial-gradient(circle 11px at 11px 22px, transparent 0 11px, #000 11.5px)',
        maskImage: 'radial-gradient(circle 11px at 11px 22px, transparent 0 11px, #000 11.5px)',
        WebkitMaskSize: '22px 22px',
        maskSize: '22px 22px',
        WebkitMaskRepeat: 'repeat-x',
        maskRepeat: 'repeat-x',
      }}
    />
  );
}
